module.exports = __webpack_public_path__ + "static/media/top-nfts-2.c75c6a19.jpg";